import React, { useState } from "react";
import {
  Link,
  matchPath,
  Outlet,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { Offcanvas } from "react-bootstrap";

import logoIcon from "../../assets/images/logo-icon.png";
import { EMPTY_STRING, SCREEN_PATH } from "../../constants";
import Topbar from "../Topbar";
import AdminSidebar from "./AdminSidebar";
import AdminPasswordModal from "./AdminPasswordModal";

const AdminLayout = () => {
  const { pathname } = useLocation();

  const isDetailsPage = !!matchPath(
    SCREEN_PATH.ADMIN_PROPERTY_DETAILS,
    pathname
  );

  const [openSidebar, setOpenSidebar] = useState(false);
  const [passwordModalOpen, setPasswordModalOpen] = useState(false);
  const navigate = useNavigate();
  const openPasswordModal = () => setPasswordModalOpen(true);
  const closePasswordModal = () => setPasswordModalOpen(false);
  const handleCloseSidebar = () => setOpenSidebar(false);
  const handleShowSidebar = () => setOpenSidebar(true);

  const navigateToPath = (path) => {
    if (path) navigate(path);
    handleCloseSidebar();
  };
  return (
    <div className="admin-layout">
      <Topbar
        handleShowSidebar={handleShowSidebar}
        openPasswordModal={openPasswordModal}
      />
      <AdminPasswordModal
        show={passwordModalOpen}
        onClose={closePasswordModal}
      />
      <Offcanvas show={openSidebar} onHide={handleCloseSidebar}>
        <Offcanvas.Header closeButton>
          <Link
            to={SCREEN_PATH.ADMIN_DASHBOARD}
            onClick={handleCloseSidebar}
            className="d-flex align-items-center text-black text-decoration-none"
          >
            <img src={logoIcon} height={46} width={46} />
            <p className="brand-logo">Bayview Shores</p>

            {/* <img src={Logo} alt={EMPTY_STRING} /> */}
          </Link>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <AdminSidebar navigateToPath={navigateToPath} />
        </Offcanvas.Body>
      </Offcanvas>
      <AdminSidebar
        className={`d-none d-md-block ${
          isDetailsPage ? "d-none d-md-none" : EMPTY_STRING
        }`}
        navigateToPath={navigateToPath}
      />
      <div
        className={`admin-outlet-container ${
          isDetailsPage ? "detail-page-wrapper" : EMPTY_STRING
        }`}
      >
        <Outlet />
      </div>
    </div>
  );
};

export default AdminLayout;
